import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Pave } from '../models/pave.model';

@Injectable({
    providedIn: 'root'
})
export class PaveService {
    apiUrl = environment.apiUrl;
    paves: Pave[];

    constructor(private http: HttpClient) { }

    get(id_instance?: number): Observable<Pave[]> {
        const params = id_instance ? new HttpParams().set('id_instance', id_instance.toString()) : null;
        return this.http.get(`${this.apiUrl}/paves`, {params: params}).pipe(
            map((res) => {
                this.paves = res['data'];
                return this.paves;
            }),
        catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }
}
